<template>
  <div>
    <el-input size="mini" v-model="tag.tag_name" @change="editTag('name', tag.tag_id, tag.tag_name, index)" @blur="closeEditTag()" :id="tag.tag_id" style="width:300px"></el-input>
  </div>
</template>

<script>
export default {
  name: "customizeTagDrawerDropdown",
  props: {
    tag: { type: Object },
    index: { type: Number, default: -1 },
  },
  data() {
    return {

    };
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    editTag(type, tag_id, value, index) {
      this.$emit("editTag", type, tag_id, value, index);
    },
    closeEditTag() {
      this.$emit("closeEditTag");
    },
  },
  watch: {},
};
</script>
